import { render, staticRenderFns } from "./CartaInstruccionTemplate.vue?vue&type=template&id=ddbb0f92"
import script from "./CartaInstruccionTemplate.vue?vue&type=script&lang=js"
export * from "./CartaInstruccionTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddbb0f92')) {
      api.createRecord('ddbb0f92', component.options)
    } else {
      api.reload('ddbb0f92', component.options)
    }
    module.hot.accept("./CartaInstruccionTemplate.vue?vue&type=template&id=ddbb0f92", function () {
      api.rerender('ddbb0f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/CartaInstruccionTemplate.vue"
export default component.exports